import React from 'react';
import {Switch} from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Followup from './followup';
import FollowupDetail from './followup-detail';
import FollowupUpdate from './followup-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={FollowupUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={FollowupUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={FollowupDetail} />
      <ErrorBoundaryRoute path={match.url} component={Followup} />
    </Switch>
  </>
);

export default Routes;
